import { Theme } from '@mui/material';


const DateTimePicker = (theme: Theme) => {
  return {
    MuiPickersTextField: {
      defaultProps: {
        fullWidth: true,
      },
      styleOverrides: {
        root: {
          'fieldset': {
            borderColor: '#e2e8f0',
            borderRadius: '10px',
          },
        },
      },
    },
  };
};

export default DateTimePicker;
